import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { ReportShowClick } from '../../../config/Validate';
import { applicationNameList, defaultPageRowOptions, defaultRowOptions, feeRegisterType, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { APPLICATIONREGISTERREPORT, DOWNLOADAPPLICATIONREGITERREPORT, DOWNLOADFEEREGISTER, DOWNLOADNIOSLETTER, FEEREGISTERREPORT, NIOSLETTER } from '../../../config/ApiConstant';
import { FeeRegFirstListColumns, FeeRegSummaryListColumns } from '../../../appconfig/DatatableSetting';
import { amountCommonTemplate, amountTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { amountFormate, downloadData, exportData } from '../../../appconfig/AppHelper';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const FeeRegisterReport = () => {
    document.title = 'Fee Register | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedFee, setSelectedFee] = useState<any>(null);
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [feeRegisterList, setFeeRegisterList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [columnName, setColumnName] = useState<any>(FeeRegFirstListColumns);

    //total
    const [feeRegisterDevelopmentTotal, setFeeRegisterDevelopmentTotal] = useState<any>(null);
    const [feeRegisterOtherTotal, setFeeRegisterOtherTotal] = useState<any>(null);
    const [feeRegisterTotal, setFeeRegisterTotal] = useState<any>(null);

    const [appTotal, setAppTotal] = useState<any>(null);
    const [adminTotal, setAdminTotal] = useState<any>(null);
    const [otherTotal, setOtherTotal] = useState<any>(null);
    const [tTotal, setTTotal] = useState<any>(null);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 30)),
        end: new Date()
    });

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <Dropdown
                        value={selectedFee}
                        name="application"
                        options={feeRegisterType}
                        filter
                        optionLabel="name"
                        placeholder="Select Fee"
                        onChange={(e) => setSelectedFee(e.value)}
                        className={errors['application'] ? 'p-invalid mr-2' : 'mr-2'}
                    />
                    <small className="p-invalid-txt">{errors['application']}</small>
                </div>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button label="Show" onClick={() => getFeeRegisterData()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate,
                type: selectedFee?.code
            };

            const response = await downloadData(DOWNLOADFEEREGISTER, 'FeeRegister', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('FeeRegister');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getFeeRegisterDataList
    const getFeeRegisterData = async () => {
        try {
            const { errors, isError } = ReportShowClick(selectedFee);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);
                if (selectedFee?.code === 'fee_summary') {
                    setColumnName(FeeRegSummaryListColumns);
                } else {
                    setColumnName(FeeRegFirstListColumns);
                }
                let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
                let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
                // Request Data
                const requestData = {
                    start_date: startDate,
                    end_date: endDate,
                    type: selectedFee?.code
                };

                const response = await postAllData(FEEREGISTERREPORT, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setFeeRegisterList(response);
                    getAllTotals(response);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const getAllTotals = (feeRegisterList:any) => {
        let appTotals = 0;
        let adminTotals = 0;
        let otherTotals = 0;
        let tTotals = 0;

        let feeReportDevTotal = 0;
        let feeReportOtherTotal = 0;
        let feeReportTotal = 0;
        if (pageLoad && selectedFee?.code == 'fee_register') {
            if (!window.cn(feeRegisterList) && feeRegisterList.length > 0) {
                feeRegisterList.map(function (feeReport: any, index: any) {
                    feeReportDevTotal += Number(feeReport?.AdminAmt);
                    feeReportOtherTotal += Number(feeReport?.OthAmt);
                    feeReportTotal += Number(feeReport?.NetAmt);
                });
            }
            setFeeRegisterDevelopmentTotal(feeReportDevTotal);
            setFeeRegisterOtherTotal(feeReportOtherTotal);
            setFeeRegisterTotal(feeReportTotal);
        } else {
            if (pageLoad) {
                if (!window.cn(feeRegisterList) && feeRegisterList.length > 0) {
                    feeRegisterList.map(function (feeSummary: any, index: any) {
                        appTotals += Number(feeSummary?.app_count);
                        adminTotals += Number(feeSummary?.admin_total);
                        otherTotals += Number(feeSummary?.other_total);
                        tTotals += Number(feeSummary?.total_amount);
                    });
                }
                setAppTotal(appTotals);
                setAdminTotal(adminTotals);
                setOtherTotal(otherTotals);
                setTTotal(tTotals);
            }
        }
    };

    //bill No template
    const billNoTemplate = (rowData: any) => {
        return <>{rowData?.BillSrNo + '/' + rowData?.CrYear}</>;
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Fee Register'} pageTitle={'Fee Register'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={feeRegisterList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {columnName.map((col: any, i: any) => {
                                        if (col.field === 'PayDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'ValidUpTo') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'OthAmt' || col.field === 'other_total') {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    body={amountCommonTemplate}
                                                    footer={selectedFee?.code === 'fee_register' ? (feeRegisterOtherTotal) : (otherTotal)}
                                                />
                                            );
                                        } else if (col.field === 'AdminAmt' || col.field === 'admin_total') {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    body={amountCommonTemplate}
                                                    footer={selectedFee?.code === 'fee_register' ? (feeRegisterDevelopmentTotal) : (adminTotal)}
                                                />
                                            );
                                        } else if (col.field === 'NetAmt' || col.field === 'total_amount') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} footer={selectedFee?.code === 'fee_register' ? (feeRegisterTotal) : (tTotal)} />;
                                        } else if (col.field === 'app_count') {
                                            return <Column key={col.field} field={col.field} header={col.header} footer={appTotal} />;
                                        } else if (col.field === 'BillSr') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={billNoTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} footer={pageLoad === true ? 'Total' : ''} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {columnName.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
